import { capitalizeString } from "../../../../utils/helpers/capitalizeString";

export const formatErrorMessage = (errorMessage: string) => {
  const removeCamelCase = errorMessage.replace(/([a-z])([A-Z])/g, "$1 $2");
  const splitWords = removeCamelCase.split(/[_\s]+/);

  return splitWords.map((word) => capitalizeString(word)).join(" ");
};
